import { Carousel } from '../core'

$.fn.projectGallery = function() {
  let self = this
  self.carousel = undefined

  return function() {
    self.carousel = new Carousel(self.find('.swiper-container').get(0), {
      slidesPerView: 1,
      autoHeight: true,
      loop: true,
      navigation: {
        prevEl: self.find('.swiper-button-prev').get(0),
        nextEl: self.find('.swiper-button-next').get(0),
      },
    })
    self.carousel.init()
    return self
  }()
}
